import { RollsetPage } from "./RollsetPage";

const Rollset = () => {
	return <RollsetPage />;
};
export default Rollset;
